<template>

  <div>
    <BCard class="pb-0">
      <BRow>
        
        <BCol cols="12" xl="6" class="d-flex justify-content-between flex-column" >
          <!-- Student Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <BAvatar :src="student.avatar" :text="avatarText(student.full_name)" size="104px" rounded />
                    <div class="d-flex flex-column ml-1">
                        <div class="mb-1">
                            <h4 class="mb-0"> {{ student.full_name }} </h4>
                            <span class="card-text">{{ student.email }}</span>
                          </div>
                          <div class="d-flex flex-wrap">
                            <BButton :to="{ name: 'students-edit', params: { id: student.id } }" variant="primary" > {{$t('Edit')}} </BButton>
                            <BButton class="ml-1" v-if="student.status==-1"  variant="success" @click="validateStudent"> Aceptar </BButton>
                            <BButton class="ml-1" v-if="student.status==-1" variant="danger" @click="deletePopupAxios(student.id, `students/${student.id}`, 'students')"> Rechazar </BButton>
                            
                            <BButton v-if="student.status!=-1" variant="outline-danger" class="ml-1" @click="deletePopupAxios(student.id, `students/${student.id}`, 'students')"> {{$t('Delete')}} </BButton>
                          </div>
                        </div>
                      </div>
          </BCol>
        </BRow>
      </BCard>
                
  </div>
  </template>
  
<script>
import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import { inject } from '@vue/composition-api'
import ViewData from '@/components/ViewData.vue'
import dateUtils from '@/hooks/dateUtils'
import { avatarText } from '@core/utils/filter'
import popups from '@/hooks/popups'

  
export default {
  components: { BCard, BButton, BRow, BCol, BAvatar, BFormCheckbox, ViewData },
  setup() {
    const student = inject('student')
    const { formatDate } = dateUtils()
    const { deletePopupAxios } = popups()

    return {
      avatarText,
      student,
      formatDate,
      deletePopupAxios
    }
  },
}
</script>
  
<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th, .title {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
  